export default {
  headline: 'Benachrichtigungskanäle',
  subheadline: 'Richten Sie Ihre Benachrichtigungskanäle ein, indem Sie einen davon aufrufen',
  headerType: 'Kanalart',
};
